// The free Starter Kit, delivered straight from the page (no email, nothing stored).
// PDFs live in public/kit/ and are generated by `node scripts/build-kit.mjs` from
// scripts/kit-content.mjs. Keep the region keys here in sync with that file.
export const KIT_BASE = '/kit/'

export const kitCore = [
  { file: 'original-savage-2-week-water-food-baseline.pdf', label: 'The 2-Week Water & Food Baseline' },
  { file: 'original-savage-home-hardening-checklist.pdf', label: 'Home Hardening Starter Checklist' },
]

export const kitRegions = [
  { key: 'gulf-atlantic', label: 'Gulf & Atlantic Coast', blurb: 'Hurricanes, flooding, long outages' },
  { key: 'west', label: 'West & Pacific', blurb: 'Wildfire, smoke, earthquakes' },
  { key: 'central', label: 'Central & Plains', blurb: 'Tornadoes, severe storms, flash floods' },
  { key: 'north', label: 'North, Midwest & Mountain', blurb: 'Winter storms, extreme cold, ice' },
  { key: 'general', label: 'Anywhere else / outside the US', blurb: 'Grid-down baseline, floods' },
] as const

export const regionFile = (key: string) => `original-savage-region-playbook-${key}.pdf`
